import axios from "axios";

export function internalViewLogin(params) {
  let endpoint = "internalview";

  if (params.v2) {
    endpoint = "internalviewv2";
  }
  return axios
    .post(endpoint, { Id: params.id })
    .then((response) => {
      return response && response.data;
    })
    .catch((error) => {
      return error && error.response && error.response.data;
    });
}
